import './App.css';
import Header from './components/Header/Header';
import "../node_modules/bootstrap/dist/css/bootstrap.min.css"
import Footer from './components/Footer/Footer';
import Shop from './components/Shop/Shop';

function App() {
  return (
    <div className="App">
     <Header></Header>
     <Shop></Shop>
     <Footer></Footer>
    </div>
  );
}

export default App;
